import { render, staticRenderFns } from "./CTooltip.vue?vue&type=template&id=22f5c033&scoped=true&"
import script from "./CTooltip.vue?vue&type=script&lang=ts&"
export * from "./CTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./CTooltip.vue?vue&type=style&index=0&id=22f5c033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5c033",
  null
  
)

export default component.exports